module.exports = __webpack_public_path__ + "static/img/15.d410611.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/15.jpg
// module id = QeFu
// module chunks = 16